import {Injectable, OnDestroy} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {ComponentType} from '@angular/cdk/portal';
import {take, takeUntil} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {BreakpointObserver, Breakpoints, BreakpointState} from '@angular/cdk/layout';

@Injectable({
  providedIn: 'root'
})
export class GenericDialogService implements OnDestroy {
  private destroyed$: Subject<void> = new Subject<void>();
  private isMobile: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Handset,
  ).pipe(
    takeUntil(this.destroyed$),
  );

  constructor(private dialog: MatDialog,
              private readonly breakpointObserver: BreakpointObserver,) {
  }

  open<T, D = any, R = any>(component: ComponentType<T>, config?: MatDialogConfig<D>): MatDialogRef<T, R> {
    const dialogRef = this.dialog.open(component, {
      disableClose: true,
      autoFocus: true,
      panelClass: 'dialog--no-padding',
      maxWidth: '100vw',
      maxHeight: '90vh',
      ...config,
    });

    const isMobileSubscription = this.isMobile.subscribe(size => {
      if (size.matches) {
        dialogRef.updateSize('95vw');
      } else {
        dialogRef.updateSize('fit-content');
      }
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe(() => {
      isMobileSubscription.unsubscribe();
    });

    return dialogRef;
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
